if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';


        jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
              function() {
                jQuery(this).closest(".card_product_variant").addClass("show_var");
              },
              function() {
                jQuery(".card_product_variant").removeClass("show_var");
              }
            );
        
        console.log("Asd");
        jQuery(".variant-button").click(function () {
          console.log("aa");
        var vals = jQuery(this).prev('input[name="id"]').attr('data-variant-id');
        console.log("valss:" + vals);
        var qty = jQuery(this).parents(".card__information").find('input[name="quantity"]').val();
        console.log("qtys:" + qty);

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                "id": vals,
                "quantity": qty
            },
           
             success: function(){ 
           
               jQuery("body").addClass("overflow-hidden");
               jQuery('cart-drawer').removeClass('is-empty');
                jQuery('.drawer__inner-empty').hide();
                jQuery('cart-drawer').load(location.href + " #CartDrawer");
                jQuery(".cart_item_clear_btn").addClass("active");

               jQuery('cart-drawer').addClass('overlay');
                
                // Set a timeout to remove the class after 5 seconds
                setTimeout(function () {
                	jQuery('cart-drawer').removeClass('overlay');
                }, 5000);
               
               setTimeout(function(){
                    jQuery('cart-drawer').load(location.href + " #CartDrawer");
                    jQuery(".cart_item_clear_btn").addClass("active");
                    jQuery(".drawer").addClass('active animate');
                    jQuery(".drawer__header").click(function(e){
                      e.preventDefault();
                      console.log("adsasdasd");
                    });

                    setTimeout(function(){
                   jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                      function() {
                        jQuery(this).closest(".card_product_variant").addClass("show_var");
                      },
                      function() {
                        jQuery(".card_product_variant").removeClass("show_var");
                      }
                    );
                    }, 2500); 
  
                   jQuery.getJSON('/cart.js', function(cart){ 
                      var result = cart.item_count;
                    console.log('main' + result);
                     jQuery(".header__icon--cart .cart-count-bubble > span").text(result);

                     jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                      function() {
                        jQuery(this).closest(".card_product_variant").addClass("show_var");
                      },
                      function() {
                        jQuery(".card_product_variant").removeClass("show_var");
                      }
                    );
                     
                   });
                },2500); 
            },
            error: function () {
                console.log("error");
            }
        });
    });
        
      }

  
      onSubmitHandler(evt) {
        evt.preventDefault();

        console.log("aaa");
        setTimeout(function(){

        jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
              function() {
                jQuery(this).closest(".card_product_variant").addClass("show_var");
              },
              function() {
                jQuery(".card_product_variant").removeClass("show_var");
              }
            );

           jQuery('cart-drawer').addClass('overlay');
                
            // Set a timeout to remove the class after 5 seconds
            setTimeout(function () {
                jQuery('cart-drawer').removeClass('overlay');
            }, 5000);
               

          
          
 //           $(".cart-quantity").change(function() {
 //              var variantId = $(this).find("option:selected").attr("data-variant-id");
 //              var quantity = $(this).val();
          
 //              // Check if the quantity is 0 or less, and remove the item if true
 //              if (parseInt(quantity) <= 0) {
 //                  $.ajax({
 //                      type: "POST",
 //                      url: "/cart/update.js",
 //                      data: {
 //                          "updates": {
 //                              [variantId]: 0 // Set the quantity to 0 to remove the item
 //                          }
 //                      },
 //                      success: function() {
 //                          // Handle success, e.g., update the UI
 //                          console.log("Product removed from the cart");
 //                      },
 //                      error: function() {
 //                          console.log('Error removing product from the cart');
 //                      }
 //                  });
 //              } else {
 //                  // Quantity is greater than 0, perform the regular quantity update
 //                  $.ajax({
 //                      type: "POST",
 //                      url: "/cart/update.js",
 //                      data: {
 //                          "updates": {
 //                              [variantId]: quantity
 //                          }
 //                      },
 //                      success: function() {
 //                          // Handle success, e.g., update the UI
 //                        //$('cart-drawer').load(location.href + " #CartDrawer");
                        
 //                          console.log("Quantity updated in the cart");
 //                          $.getJSON('/cart.js', function(cart){ 
 //                           var result = cart.item_count;
 //                           console.log(result);
 //                           $(".header__icon--cart .cart-count-bubble > span").text(result);
 //                         });
                        
 //                      },
 //                      error: function() {
 //                          console.log('Error updating quantity in the cart');
 //                      }
 //                  });
 //              }
 //          });

 //           $(document).on("click", ".cart_submit_btn", function(e) {
 //              e.preventDefault();
            
 //              	var data_vals = $(this).parents(".ctn_button").find('input[name="id"]').val();
	// console.log(data_vals);

	// var qty = $(this).parents(".ctn_button").find('input[name="quantity"]').val();   
	// console.log(qty);

	//   $.ajax({
 //            type: "POST",
 //            url: "/cart/add.js",
 //            data: {
 //                "id": data_vals,
 //                "quantity": qty
 //            },
 //            success: function(){ 
 //               $('cart-drawer').removeClass('is-empty');
 //                $('.drawer__inner-empty').hide();
 //                $('cart-drawer').load(location.href + " #CartDrawer");
 //                $(".cart_item_clear_btn").addClass("active");
 //               setTimeout(function(){
 //                    $(".cart_item_clear_btn").addClass("active");
 //                    $(".drawer").addClass('active animate');
 //                    $(".drawer__header").click(function(e){
 //                      e.preventDefault();
 //                      console.log("adsasdasd");
 //                    });
      
 //                   $.getJSON('/cart.js', function(cart){ 
 //                     var result = cart.item_count;
 //                    console.log(result);
 //                     $(".header__icon--cart .cart-count-bubble > span").text(result);
 //                   });
 //                },1000); 
 //            },
 //            error: function () {
 //                console.log("error");
 //            }
 //        });
 //           });

          jQuery(document).on('click', '.variant-button-cart', function(){
    console.log("asdasdasd");
      var vals = jQuery(this).prev('input[name="id"]').attr('data-variant-id');
        console.log("valss:" + vals);
        var qty = jQuery(this).parents(".card__information").find('input[name="quantity"]').val();
        console.log("qtys:" + qty);

        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                "id": vals,
                "quantity": qty
            },
           
             success: function(){ 
               jQuery("body").addClass("overflow-hidden");
               jQuery('cart-drawer').removeClass('is-empty');
                jQuery('.drawer__inner-empty').hide();
                jQuery('cart-drawer').load(location.href + " #CartDrawer");
                jQuery(".cart_item_clear_btn").addClass("active");

                jQuery('cart-drawer').addClass('overlay');
                
                // Set a timeout to remove the class after 5 seconds
                setTimeout(function () {
                	jQuery('cart-drawer').removeClass('overlay');
                }, 5000);

               
               setTimeout(function(){
                    jQuery('cart-drawer').load(location.href + " #CartDrawer");
                    jQuery(".cart_item_clear_btn").addClass("active");
                    jQuery(".drawer").addClass('active animate');
                    jQuery(".drawer__header").click(function(e){
                      e.preventDefault();
                      console.log("adsasdasd");
                    });

                    setTimeout(function(){
                   jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                      function() {
                        jQuery(this).closest(".card_product_variant").addClass("show_var");
                      },
                      function() {
                        jQuery(".card_product_variant").removeClass("show_var");
                      }
                    );
                    }, 2500); 
  
                   jQuery.getJSON('/cart.js', function(cart){ 
                     var result = cart.item_count;
                    console.log('mainss' + result);
                     jQuery(".header__icon--cart .cart-count-bubble > span").text(result);

                     jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                      function() {
                        jQuery(this).closest(".card_product_variant").addClass("show_var");
                      },
                      function() {
                        jQuery(".card_product_variant").removeClass("show_var");
                      }
                    );
                     
                   });
                },2500); 
            },
            error: function () {
                console.log("error");
            }
        });
});

         /* code */ 
//           jQuery(".cart-quantitys").change(function () {
//           console.log('aa');
//       /* sum */
            
//       setTimeout(function(){
//             var totalSum = 0;

//             jQuery(".cart-item").each(function() {
//                 // Get the selected option text and convert it to a float
//                 var vals = parseFloat(jQuery(this).find("option:selected").text());
//                 console.log("Vals: " + vals);
            
//                 // Get the price text
//                 var price = jQuery(this).find(".cart-item__details > .product-option").text();
            
//                 // Remove the dollar sign from the price and convert to a float
//                 var priceFloat = parseFloat(price.replace("$", ""));
//                 console.log("Price: " + priceFloat);
            
//                 // Multiply vals and priceFloat
//                 var result = vals * priceFloat;
//                 console.log("Result: " + result);
            
//                 // Format the result to two decimal places with a dollar sign
//                 var formattedResult = '$' + result.toFixed(2);
//                 console.log("Formatted Result: " + formattedResult);
            
//                 // Update the HTML element with the formatted result
//                 jQuery(this).find(".cart-item__totals .price.price--end").text(formattedResult);
            
//                 // Accumulate the result to the total sum
//                 totalSum += result;
//             });
            
//             // Round the total sum to two decimal places
//             totalSum = totalSum.toFixed(2);
            
//             // Format the total sum with a dollar sign
//             var formattedTotalSum = '$' + totalSum;
            
//             // Output the total sum after the loop
//             console.log(formattedTotalSum);
            
//             // Update the HTML element with the formatted total sum
//             jQuery(".cart-drawer__footer .totals .totals__total-value").text(formattedTotalSum);
          
//         }, 1000);
                  
//           var variantId = jQuery(this).find("option:selected").data("variant-id"); // Use data() method to get data attributes
//           var quantity = jQuery(this).val();
      
//           // Check if the quantity is 0 or less, and remove the item if true
//           if (parseInt(quantity) <= 0) {
//               updateCart(variantId, 0);
//           } else {
//               updateCart(variantId, quantity);
//           }
// });


          jQuery(document).on("change", ".cart-quantitys", function () {
      console.log("aaaaa");

         /* sum */ 
        setTimeout(function(){
            var totalSum = 0;

            jQuery(".cart-item").each(function() {
                // Get the selected option text and convert it to a float
                var vals = parseFloat(jQuery(this).find("option:selected").text());
                console.log("Vals: " + vals);
            
                // Get the price text
                var price = jQuery(this).find(".cart-item__details > .product-option").text();
            
                // Remove the dollar sign from the price and convert to a float
                var priceFloat = parseFloat(price.replace("$", ""));
                console.log("Price: " + priceFloat);
            
                // Multiply vals and priceFloat
                var result = vals * priceFloat;
                console.log("Result: " + result);
            
                // Format the result to two decimal places with a dollar sign
                var formattedResult = '$' + result.toFixed(2);
                console.log("Formatted Result: " + formattedResult);
            
                // Update the HTML element with the formatted result
                jQuery(this).find(".cart-item__totals .price.price--end").text(formattedResult);
            
                // Accumulate the result to the total sum
                totalSum += result;
            });
            
            // Round the total sum to two decimal places
            totalSum = totalSum.toFixed(2);
            
            // Format the total sum with a dollar sign
            var formattedTotalSum = '$' + totalSum;
            
            // Output the total sum after the loop
            console.log(formattedTotalSum);
            
            // Update the HTML element with the formatted total sum
            jQuery(".cart-drawer__footer .totals .totals__total-value").text(formattedTotalSum);
          
        }, 500);
        
      var variantId = $(this).find("option:selected").attr("data-variant-id");
      var quantity = $(this).val();
      
      // Check if the quantity is 0 or less, and remove the item if true
      if (parseInt(quantity) <= 0) {
        jQuery.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: {
                "updates": {
                    [variantId]: 0 // Set the quantity to 0 to remove the item
                }
            },
            success: function () {
              jQuery("body").addClass("overflow-hidden");
                // Handle success, e.g., update the UI
                console.log("Product removed from the cart");
                // Retrieve updated cart information
                jQuery.getJSON('/cart.js', function (cart) {
                    var result = cart.item_count;
                    console.log(result);
                    jQuery(".header__icon--cart .cart-count-bubble > span").text(result);
                    jQuery(".drawer__header .price_count").text(result); 
                });
              
            },
            error: function () {
                console.log('Error removing product from the cart');
            }
        });
      } else {
        // Quantity is greater than 0, perform the regular quantity update
        jQuery.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: {
                "updates": {
                    [variantId]: quantity
                }
            },
            success: function () {
              jQuery("body").addClass("overflow-hidden");
                // Retrieve updated cart information
                jQuery.getJSON('/cart.js', function (cart) {
                    var result = cart.item_count;
                    console.log(result);
                    jQuery(".header__icon--cart .cart-count-bubble > span").text(result);
                    jQuery(".drawer__header .price_count").text(result); 
                });
            },
            error: function () {
                console.log('Error updating quantity in the cart');
            }
        });
      }
      
      });
jQuery(document).on("click", ".cart_submit_btn", function (e) {
    e.preventDefault();
    console.log('yess');
    var data_vals = jQuery(this).closest(".ctn_button").find('input[name="id"]').val(); // Use closest() instead of parents()
    var qty = jQuery(this).closest(".ctn_button").find('input[name="quantity"]').val();

    addToCart(data_vals, qty);
});

function updateCart(variantId, quantity) {
    jQuery.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: {
            "updates": {
                [variantId]: quantity
            }
        },
        success: function () {
            console.log("Quantity updated in the cart");
            updateCartCount();
        },
        error: function () {
            console.log('Error updating quantity in the cart');
        }
    });
}

function addToCart(data_vals, qty) {
    jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            "id": data_vals,
            "quantity": qty
        },
        success: function () {
            console.log("Product added to the cart");

            jQuery('.drawer__inner-empty').hide();
            // $('.cart-drawer').load(location.href + " .cart-drawer"); // Correct the selector here
            // $(".cart_item_clear_btn").addClass("active");
            // setTimeout(function () {
            //     $(".cart_item_clear_btn").addClass("active");
            //     $(".drawer").addClass('active animate');
            //     $(".drawer__header").click(function (e) {
            //         e.preventDefault();
            //         console.log("adsasdasd");
            //     });

            //     $.getJSON('/cart.js', function (cart) {
            //         var result = cart.item_count;
            //         console.log(result);
            //         $(".header__icon--cart .cart-count-bubble > span").text(result);
            //     });
            // }, 1000);
                jQuery("body").addClass("overflow-hidden");
                jQuery('cart-drawer').removeClass('is-empty');
                jQueryjQueryjQuery('.drawer__inner-empty').hide();
                jQueryjQuery('cart-drawer').load(location.href + " #CartDrawer");
                jQuery(".cart_item_clear_btn").addClass("active");
               setTimeout(function(){
                    jQuery(".cart_item_clear_btn").addClass("active");
                    jQuery(".drawer").addClass('active animate');
                    jQuery(".drawer__header").click(function(e){
                      e.preventDefault();
                      console.log("adsasdasd");
                    });

                 setTimeout(function(){
                   jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                      function() {
                        jQuery(this).closest(".card_product_variant").addClass("show_var");
                      },
                      function() {
                        jQuery(".card_product_variant").removeClass("show_var");
                      }
                    );
                    }, 2000); 
                 
                   jQuery.getJSON('/cart.js', function(cart){ 
                     var result = cart.item_count;
                    console.log(result);
                     jQuery(".header__icon--cart .cart-count-bubble > span").text(result);
                     jQuery(".drawer__header .price_count").text(result);

                     jQuery(".instant_saving_cart_item_block .product_variant_block, .instant_saving_cart_item_block .cart-btn").hover(
                      function() {
                        jQuery(this).closest(".card_product_variant").addClass("show_var");
                      },
                      function() {
                        jQuery(".card_product_variant").removeClass("show_var");
                      }
                    );
                     
                   });
                },500); 

            // Additional logic or UI updates can be added here
        },
        error: function () {
            console.log("Error adding product to the cart");
        }
    });
}

function updateCartCount() {
    jQuery.getJSON('/cart.js', function (cart) {
        var result = cart.item_count;
        console.log(result);
        jQuery(".header__icon--cart .cart-count-bubble > span").text(result);
        jQuery(".drawer__header .price_count").text(result);
    });
}


  /* new code  */
          
//    $(document).ready(function () {
//     $(".cart-quantity").change(function () {
//         console.log('aa');
//         var variantId = $(this).find("option:selected").attr("data-variant-id");
//         var quantity = $(this).val();

//         // Check if the quantity is 0 or less, and remove the item if true
//         if (parseInt(quantity) <= 0) {
//             updateCart(variantId, 0);
//         } else {
//             updateCart(variantId, quantity);
//         }
//     });

//     $(document).on("click", ".cart_submit_btn", function (e) {
//         e.preventDefault();
//         console.log('yess');
//         var data_vals = $(this).parents(".ctn_button").find('input[name="id"]').val();
//         var qty = $(this).parents(".ctn_button").find('input[name="quantity"]').val();

//         addToCart(data_vals, qty);
//     });

//     function updateCart(variantId, quantity) {
//         $.ajax({
//             type: "POST",
//             url: "/cart/update.js",
//             data: {
//                 "updates": {
//                     [variantId]: quantity
//                 }
//             },
//             success: function () {
//                 console.log("Quantity updated in the cart");
//                 updateCartCount();
//             },
//             error: function () {
//                 console.log('Error updating quantity in the cart');
//             }
//         });
//     }

//     function addToCart(data_vals, qty) {
//         $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             data: {
//                 "id": data_vals,
//                 "quantity": qty
//             },
//             success: function () {
              
//                 console.log("Product added to the cart");
//                 $('.cart-drawer').removeClass('is-empty');
//                 $('.drawer__inner-empty').hide();
//                 // $('.cart-drawer').load(location.href + " .cart-drawer > *");
//                  $('.cart-drawer').load(location.href + " #CartDrawer");            
//                 $(".cart_item_clear_btn").addClass("active");
//                 updateCartCount();
//                 // Additional logic or UI updates can be added here
//             },
//             error: function () {
//                 console.log("Error adding product to the cart");
//             }
//         });
//     }

//     function updateCartCount() {
//          $('.cart-drawer').load(location.href + " #CartDrawer");
//         //$('.cart-drawer').load(location.href + " .cart-drawer > *");
//         $.getJSON('/cart.js', function (cart) {
//             var result = cart.item_count;
//             console.log(result);
//             $(".header__icon--cart .cart-count-bubble > span").text(result);
//         });
//     }
// });

          
        }, 2000);
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            console.log("aaaaaaaa");
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });   
              
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
